import { TooltipWrapper } from "@src/components/deprecated/DeprecatedTooltip/TooltipWrapper";
import { StatusTag, StatusTagColor } from "@src/components/deprecated/StatusTag/StatusTag";
import { useTags } from "data-hooks/company/tags/tags.service";
import { formatTagName } from "data-hooks/company/tags/tags.utils";
import { CustomFieldCellProps } from "./CustomFieldCell";

export const CustomFieldTagCell = ({ value }: CustomFieldCellProps) => {
  const tagIDs = Array.isArray(value) ? value : [value];

  return <TableTagCell tagIDs={tagIDs} />;
};

export const TableTagCell = ({ tagIDs }: { tagIDs: string[] | undefined }) => {
  const { tags } = useTags({}, {});
  const selectedTags = tags?.filter((tag) => tagIDs?.includes(tag.id)) ?? [];

  return selectedTags.length > 0 ? (
    <div style={{ paddingTop: 4 }}>
      {selectedTags.map((tag) => {
        return (
          <TooltipWrapper
            key={tag.id}
            trigger={
              <StatusTag color={tag.badgeColor as StatusTagColor} text={formatTagName(tag)} display="inline-block" marginRight={4} marginBottom={4} />
            }
            title={tag.description}
          />
        );
      })}
    </div>
  ) : null;
};
